import {
  BaSeButton,
  BaSeDialogConsumer,
  BaSeLoadingPage,
  BaSeTheme,
} from '@base/react';
import { GestaoAmeiFrame } from '@sebrae/gestao-amei-frame';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { managerLegacyPaths } from '../../routes';
import {
  BoxIframe,
  Container,
  Content,
  ContentWrapper,
  HeaderAmei,
} from './amei-management-styled';

const URL_AMEI_MANAGEMENT = 'gestaoAmeiUrl';

export const AmeiManagement = () => {
  const { navigateTo } = Sebrae.useSebraeRouter();
  const { getEnv } = Sebrae.useEnv();
  const [url, setUrl] = React.useState();

  React.useEffect(() => {
    getEnv(URL_AMEI_MANAGEMENT)
      .then(setUrl)
      .catch(() =>
        console.log(
          `Não foi possível encontrar "${URL_AMEI_MANAGEMENT}" nas variáveis de ambiente.`,
        ),
      );
  }, [getEnv]);

  return (
    <Container>
      <HeaderAmei />
      <ContentWrapper>
        <Content>
          <BaSeButton
            buttonType="button"
            color={BaSeTheme.colors.institucionais.cinzaSebrae45}
            onClick={() =>
              navigateTo(managerLegacyPaths.entrevista, { keepQueryString: true })
            }
            size="medium"
            type="tertiary"
            value="Início"
          />
          <BoxIframe>
            {url ? (
              <BaSeDialogConsumer>
                {({ showNotification }) => (
                  <GestaoAmeiFrame
                    url={url}
                    realm="externo"
                    module="role-map"
                    roleMapOptions={{
                      clientId: 'empretec-backend',
                    }}
                    events={{
                      onNotification: showNotification,
                    }}
                  />
                )}
              </BaSeDialogConsumer>
            ) : (
              <BaSeLoadingPage />
            )}
          </BoxIframe>
        </Content>
      </ContentWrapper>
    </Container>
  );
};
